import { Box, Typography, useTheme } from "@mui/material";
import React from "react";

const Footer = () => {
  const theme = useTheme();
  const fullYear = new Date();
  return (
    <Box
      sx={{
        color: theme.palette.primary.contrastText,
        bottom: "0",
        width: "100%",
        background: theme.palette.primary.main,
        height: 25,
        display: "flex",
        alignItems: "baseline",
      }}
    >
      <Box>
        <Typography variant="subtitle2">
          Copyright &copy; {`${fullYear.getFullYear()}`} Inkwell Data ltd
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
